import index from './index.vue';
import { FormData, ConnectTypeListData } from './all.type';

export default index;
export {
    FormData,
    ConnectTypeListData
};